module.exports = __webpack_public_path__ + "static/media/mode-cedeo-logo-ripeurs-blue.928677b2.png";